import React, { useState, useRef, useEffect } from 'react';
import Icon from '../shared/Icon';
import './AddDatasetMenu.css';

/**
 * The "+" affordance on the Available Datasets header. When voice recording is enabled
 * it opens a small chooser (Upload files / Record from microphone); otherwise the parent
 * should keep using the plain button that wires straight to file upload.
 */
function AddDatasetMenu({ onUpload, onRecord }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  const choose = (fn) => {
    setOpen(false);
    if (fn) fn();
  };

  return (
    <div className="add-dataset-menu" ref={wrapRef}>
      <button
        type="button"
        className="resui-btn resui-btn--secondary resui-btn--icon available-datasets-add-btn"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Add a dataset"
        title="Add a dataset"
      >
        <Icon name="add" />
      </button>
      {open && (
        <div className="add-dataset-menu-popup" role="menu">
          <button type="button" className="add-dataset-menu-item" role="menuitem" onClick={() => choose(onUpload)}>
            <Icon name="upload_file" />
            Upload files
          </button>
          <button type="button" className="add-dataset-menu-item" role="menuitem" onClick={() => choose(onRecord)}>
            <Icon name="mic" />
            Record from microphone
          </button>
        </div>
      )}
    </div>
  );
}

export default AddDatasetMenu;
